import React, { useContext, useEffect, useState } from 'react';
import Sidebar from './../Sidebar';
import Footer from './../Footer';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { site_url, site_url_img } from "../config.js";
import axios from 'axios';
import { Container, Row, Col, Button, Form, Card, Carousel, Navbar, Nav } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

function Index() {
  const { user, fulluser, setfullUser, setUser } = useContext(AuthContext);
  const [Activity, setActivity] = useState([]);
  const navigate = useNavigate();

  // Email Verification State
  const [showEmailVerify, setShowEmailVerify] = useState(false);
  const [emailOtp, setEmailOtp] = useState('');
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [emailVerifyMsg, setEmailVerifyMsg] = useState({ type: '', text: '' });
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);
  const [editingEmail, setEditingEmail] = useState(false);
  const [newEmail, setNewEmail] = useState('');
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('mpin');
    sessionStorage.setItem("mpin_verified", "false");
    setfullUser(null);
    setUser(null);
    // Delete the stored token
    // Optionally redirect user to login or home page
    navigate("/Main");

  };

  useEffect(() => {
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());
    document.body.classList.remove("modal-open");
  }, [location]);

  // Timer Logic
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleSendEmailOtp = async () => {
    const token = parseStoredAccessToken(user);
    try {
      setEmailVerifyMsg({ type: 'info', text: 'Sending OTP...' });

      const payload = {};
      // If we are editing contact email, send the new email address
      if (editingEmail && newEmail && newEmail !== fulluser?.email) {
        payload.email = newEmail;
      }

      const res = await axios.post(site_url + '/send_email_verify_otp', payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 'success') {
        setEmailOtpSent(true);
        setEmailVerifyMsg({ type: 'success', text: 'OTP sent to your email.' });
        setTimer(60);
        setCanResend(false);
        setShowEmailVerify(true); // Ensure modal opens
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Failed to send OTP.' });
        alert(res.data.message || 'Failed to send OTP');
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: err.response?.data?.message || 'Error sending OTP.' });
      alert(err.response?.data?.message || 'Error sending OTP');
    }
  };

  const handleVerifyEmailOtp = async () => {
    const token = parseStoredAccessToken(user);
    try {
      const res = await axios.post(site_url + '/verify_email_otp', { otp: emailOtp }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (res.data.status === 'success') {
        setShowEmailVerify(false);
        setShowSuccessModal(true);
        // Page reload will happen on modal close
      } else {
        setEmailVerifyMsg({ type: 'error', text: res.data.message || 'Invalid OTP.' });
      }
    } catch (err) {
      setEmailVerifyMsg({ type: 'error', text: 'Verification failed.' });
    }
  };


  return (
    <div>
      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center>Profile</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <div id="appCapsule" className='mt-4'>
        <div className="section mt-5 text-center">
          <div className="avatar-section mt-5">
            <a href="#">
              <img src={'./man.png'} alt="avatar" className="imaged w100 rounded" />
              <span className="button">
                <ion-icon name="camera-outline" role="img" className="md hydrated" aria-label="camera outline" />
              </span>
            </a>
          </div>
        </div>

        <div className="listview-title mt-1">Profile Settings</div>
        <ul className="listview image-listview text inset">
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>{fulluser?.username}</div>
              </div>
            </a>
          </li>
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>{fulluser?.phone}</div>
              </div>
            </a>
          </li>
          <li>
            <div className="item">
              <div className="in">
                <div style={{ width: '100%' }}>
                  {!editingEmail ? (
                    <div className="d-flex justify-content-between align-items-center">
                      <span>
                        {fulluser?.email || 'No Email Set'}
                        {fulluser?.email_verified_at ? (
                          <span className="badge badge-success ms-2">Verified</span>
                        ) : (
                          <span className="badge badge-warning ms-2" onClick={handleSendEmailOtp} style={{ cursor: 'pointer' }}>Verify Now</span>
                        )}
                      </span>
                      <div onClick={() => {
                        setNewEmail(fulluser?.email || '');
                        setEditingEmail(true);
                      }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', color: '#007bff' }}>
                        <ion-icon name="create-outline" style={{ fontSize: '20px', marginRight: '5px' }}></ion-icon>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>Update</span>
                      </div>
                    </div>
                  ) : (
                    <div className="d-flex align-items-center gap-2">
                      <input
                        type="email"
                        className="form-control form-control-sm"
                        value={newEmail}
                        onChange={(e) => setNewEmail(e.target.value)}
                        placeholder="Enter new email"
                      />
                      <Button size="sm" variant="primary" onClick={handleSendEmailOtp}>Save</Button>
                      <Button size="sm" variant="secondary" onClick={() => setEditingEmail(false)}>Cancel</Button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </li>



        </ul>
        <div className="listview-title mt-1">Security</div>
        <ul className="listview image-listview text mb-2 inset">
          <li>
            <a href="#" className="item">
              <div className="in">
                <div>Update Password</div>
              </div>
            </a>
          </li>

          <li>
            <a href="#" className="item" onClick={handleLogout} >
              <div className="in">
                <div>Log out all devices</div>
              </div>
            </a>
          </li>
        </ul>
      </div>

      <Footer />

      {/* Email Verification Action Sheet Modal */}
      {showEmailVerify && (
        <div
          className="modal fade action-sheet show"
          id="emailVerifyActionSheet"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Verify Email</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  {emailVerifyMsg.text && (
                    <div className={`alert alert-${emailVerifyMsg.type === 'error' ? 'danger' : emailVerifyMsg.type === 'success' ? 'success' : 'info'} mb-2`}>
                      {emailVerifyMsg.text}
                    </div>
                  )}
                  <form>
                    <div className="form-group basic">
                      <div className="input-wrapper">
                        <label className="label">Enter OTP</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter 4-digit OTP"
                          value={emailOtp}
                          onChange={(e) => setEmailOtp(e.target.value)}
                        />
                        <i className="clear-input">
                          <ion-icon name="close-circle" onClick={() => setEmailOtp('')}></ion-icon>
                        </i>
                      </div>
                    </div>

                    <div className="form-group basic mt-3">
                      <button
                        type="button"
                        className="btn btn-primary btn-block btn-lg mb-2"
                        onClick={handleVerifyEmailOtp}
                      >
                        Verify OTP
                      </button>

                      <div className="d-flex justify-content-between align-items-center px-1">
                        <button
                          type="button"
                          className="btn btn-text-secondary btn-sm"
                          onClick={() => setShowEmailVerify(false)}
                        >
                          Cancel
                        </button>

                        <button
                          type="button"
                          className="btn btn-text-primary btn-sm"
                          onClick={handleSendEmailOtp}
                          disabled={!canResend}
                          style={{ opacity: canResend ? 1 : 0.6 }}
                        >
                          {canResend ? 'Resend Code' : `Resend in ${timer}s`}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div
          className="modal fade action-sheet show"
          id="successActionSheet"
          tabIndex={-1}
          role="dialog"
          style={{ display: 'block' }}
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
              </div>
              <div className="modal-body">
                <div className="action-sheet-content">
                  <div className="text-center mb-2">
                    <div
                      style={{
                        width: '80px',
                        height: '80px',
                        backgroundColor: 'rgba(50, 168, 82, 0.1)',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 15px auto'
                      }}
                    >
                      <ion-icon name="checkmark-circle-outline" style={{ fontSize: '40px', color: '#32a852' }}></ion-icon>
                    </div>
                  </div>
                  <h3 className="text-center mb-1">Email Verified!</h3>
                  <p className="text-center mb-3">
                    Your email has been successfully verified. You will receive monthly statements and important updates.
                  </p>

                  <div className="form-group basic">
                    <button
                      type="button"
                      className="btn btn-primary btn-block btn-lg"
                      onClick={() => {
                        setShowSuccessModal(false);
                        window.location.reload();
                      }}
                    >
                      Continue
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

    </div >
  )
}

export default Index